export default function Hero() {
  return (
    <section className="bg-gradient-to-br from-orange-50 via-white to-red-50 py-16">
      <div className="max-w-6xl mx-auto px-4">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="grid md:grid-cols-2 gap-8 items-center p-8 md:p-12">
            <div>
              <div className="inline-block bg-gradient-to-r from-orange-500 to-red-500 text-white text-sm font-bold px-4 py-2 rounded-full mb-4">
                業界最高水準 1.2%還元
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                高還元率カード
              </h1>
              <p className="text-lg text-gray-600 mb-6">
                いつでもどこでも1.2%の高還元率。年会費永年無料で、提携サービスでさらにお得にポイントが貯まります。
              </p>
              <div className="flex flex-wrap gap-3 mb-6">
                <span className="bg-orange-100 text-orange-800 px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap">
                  還元率1.2%
                </span>
                <span className="bg-red-100 text-red-800 px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap">
                  年会費永年無料
                </span>
                <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap">
                  提携サービスでさらにお得
                </span>
              </div>
              <div className="bg-gradient-to-r from-orange-500 to-red-500 text-white p-6 rounded-xl">
                <p className="text-sm mb-2">新規入会&利用で</p>
                <p className="text-3xl font-bold mb-1">最大6,000円分</p>
                <p className="text-sm">ポイントプレゼント</p>
              </div>
            </div>
            <div className="relative">
              <div className="aspect-[4/3] rounded-xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/2cdf062eee5d94e6d001c3318498d59f.jpg"
                  alt="高還元率カード"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 bg-white rounded-xl shadow-lg p-4">
                <div className="text-center">
                  <p className="text-sm text-gray-600 mb-1">基本還元率</p>
                  <p className="text-3xl font-bold text-orange-600">1.2%</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
